import React from 'react';
import { SNAP_CONTAINER } from '../../libs/data/consants';

const HomeContainer = () => {
  return (
    <div className="home-container">
      <div className="payment">
        <div className="customer-details">
          <p className="title">Customer Details:</p>
          <p>Budi Utomo <br />081808466410 <br />Jl.Jend.Sudirman Kav.10-11, Jakarta 10220</p>
        </div>
        <div id={SNAP_CONTAINER} />
      </div>
    </div>
  );
};

export default HomeContainer;
